import NamedDto from 'modules/base/dto/NamedDto';
import DomainEditDto from './DomainEditDto';
import OptimizationCaseLimitEditDto from './OptimizationCaseLimitEditDto';
import OptimizationCaseTransformerAttributeEditDto from './OptimizationCaseTransformerAttributeEditDto';

export class OptimizationCaseEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.optimizer = null;
		/** @type {number} */
		this.optimizerLog = null;
		/** @type {number} */
		this.aspect = null;
		/** @type {number} */
		this.transformer = null;
		/** @type {DomainEditDto[]} */
		this.domains = null;
		/** @type {number} */
		this.imputedValue = null;
		/** @type {string} */
		this.optimizationGoal = null;
		/** @type {string} */
		this.outputKey = null;
		/** @type {number} */
		this.stepLimit = null;
		/** @type {OptimizationCaseLimitEditDto[]} */
		this.stateLimits = null;
		/** @type {OptimizationCaseLimitEditDto[]} */
		this.aspectLimits = null;
		/** @type {OptimizationCaseLimitEditDto[]} */
		this.transformerLimits = null;
		/** @type {OptimizationCaseTransformerAttributeEditDto[]} */
		this.transformerAttributes = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _OptimizationCaseEditDtoProps
	 * @property {number} optimizer
	 * @property {number} optimizerLog
	 * @property {number} aspect
	 * @property {number} transformer
	 * @property {DomainEditDto[]} domains
	 * @property {number} imputedValue
	 * @property {string} optimizationGoal
	 * @property {string} outputKey
	 * @property {number} stepLimit
	 * @property {OptimizationCaseLimitEditDto[]} stateLimits
	 * @property {OptimizationCaseLimitEditDto[]} aspectLimits
	 * @property {OptimizationCaseLimitEditDto[]} transformerLimits
	 * @property {OptimizationCaseTransformerAttributeEditDto[]} transformerAttributes
	 * @property {number} userGroup	
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationCaseEditDtoProps} OptimizationCaseEditDtoProps
	 */
	/**
	 *
	 * @param {OptimizationCaseEditDtoProps} props
	 * @returns {OptimizationCaseEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.optimizer = props.optimizer;
		this.optimizerLog = props.optimizerLog;
		this.aspect = props.aspect;
		this.transformer = props.transformer;
		this.domains = props.domains !== null ? props.domains.map(d => new DomainEditDto().setup(d)) : [];
		this.imputedValue = props.imputedValue;
		this.optimizationGoal = props.optimizationGoal;
		this.outputKey = props.outputKey;
		this.stepLimit = props.stepLimit;
		this.stateLimits = props.stateLimits != null ? props.stateLimits.map(d => new OptimizationCaseLimitEditDto().setup(d)) : [];
		this.aspectLimits = props.aspectLimits != null ? props.aspectLimits.map(d => new OptimizationCaseLimitEditDto().setup(d)) : [];
		this.transformerLimits = props.transformerLimits != null ? props.transformerLimits.map(d => new OptimizationCaseLimitEditDto().setup(d)) : [];
		this.transformerAttributes = props.transformerAttributes != null ? props.transformerAttributes.map(d => new OptimizationCaseTransformerAttributeEditDto().setup(d)) : [];
		this.userGroup = props.userGroup;
		return this;
	}
}

export default OptimizationCaseEditDto;
